  (() => {
    function addItemsToCart(itemsToAdd, $button) {
      // Add loading state
      if ($button) {
        $button.classList.add('is-loading');
        $button.disabled = true;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: itemsToAdd })
      })
      .then((res) => res.json())
      .then((data) => {
        // Check for errors
        if (data.status && data.status !== 200) {
          throw new Error(data.message || data.description || 'Error adding to cart');
        }

        // Use the theme's cart system to refresh and open drawer
        if (window.cart && typeof window.cart.getCart === 'function') {
          window.cart.getCart();
        } else {
          // Fallback: dispatch events and redirect if cart drawer not available
          document.dispatchEvent(new CustomEvent('theme:cart:added', {
            bubbles: true
          }));
          document.dispatchEvent(new CustomEvent('theme:cart:update', {
            bubbles: true
          }));
        }

        // Remove loading state after a brief delay for UX
        if ($button) {
          setTimeout(() => {
            $button.classList.remove('is-loading');
            $button.disabled = false;
          }, 300);
        }
      })
      .catch((error) => {
        console.error('Error adding bundle to cart:', error);

        // Show error to user
        if ($button) {
          const errorMsg = error.message || 'Error adding to cart';
          alert(errorMsg); // You can replace this with a more elegant notification

          $button.classList.remove('is-loading');
          $button.disabled = false;
        }
      });
    }

    document.addEventListener('DOMContentLoaded', () => {
      // Select dropdown event
      document.querySelectorAll('.bundle select[name="id"]').forEach(($select) => {
        $select.addEventListener('change', (e) => {
          let $row = e.currentTarget.closest('.upgrade-container');
          $row.dataset.variant = $select.value;
        });
      });

      // Add to cart event
      document.querySelectorAll('.bundle [data-bundle-addtocart]').forEach(($bundleAtc) => {
        $bundleAtc.addEventListener('click', (e) => {
          e.preventDefault();
          let itemsToAdd = [];
          let $rows = $bundleAtc.closest('.bundle').querySelectorAll('.upgrade-container');
          $rows.forEach(($row) => {
            let $qty = $row.querySelector('quantity-picker input[name="quantity"]');
            let qty = $qty ? parseFloat($qty.value) : 0;
            let properties = {};
            if (!$qty) {
              $qty = $row.querySelector('yard-picker input[name="yardQuantity"]');
              qty = parseFloat($qty.dataset.quantity);
              properties = {
                Yards: parseFloat($qty.dataset.yards)
              };
            }

            let itemToAdd = {
              quantity: qty,
              id: $row.dataset.variant,
              properties: properties
            };

            itemsToAdd.push(itemToAdd);
          });
          console.log({itemsToAdd});

          addItemsToCart(itemsToAdd, $bundleAtc);
        });
      });

      // try it with add to cart
      document.querySelectorAll('.upsell-block-2-prod .add-to-cart-btn').forEach(($btn) => {
        $btn.addEventListener('click', (e) => {
          e.preventDefault();
          let itemsToAdd = [];
          let $form = $btn.closest('form');
          itemsToAdd.push({quantity: 1, id: $form.querySelector('[name=id]').value});
          console.log({itemsToAdd});

          addItemsToCart(itemsToAdd, $btn);
        });
      });
    });
  })();